import React, { Component } from "react";
import Header from "./Header";
import Main from "./Main";

export default class App extends Component {
  render() {
    return (
      <div className='bg-gray-900'>
        <Header/>
        <Main/>
      </div>
    );
  }
}